import { render, staticRenderFns } from "./AnnualComparison.vue?vue&type=template&id=5067af4e&scoped=true"
import script from "./AnnualComparison.vue?vue&type=script&lang=js"
export * from "./AnnualComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067af4e",
  null
  
)

export default component.exports